import app from '../../app';
import { api } from '$$store/api';
import rights from '../../components/rights';

let apiKeys = {};

if (app.config.mode.isBase) {
  apiKeys = new webix.DataCollection();

  apiKeys.getData = function () {
    const data = apiKeys.serialize(true);

    data.sort((a, b) => {
      if (a.id > b.id) return -1;
      if (a.id < b.id) return 1;

      return 0;
    });

    return data;
  };

  apiKeys.create = function () {
    return webix.ajax().post('/api/team/apiKeys', {}, response => {
      const data = JSON.parse(response);

      if (data && data.apiKey) {
        apiKeys.add(data.apiKey);
      }
    });
  };

  apiKeys.delete = function (id) {
    return webix.ajax().del('/api/team/apiKeys', { id }, response => {
      const data = JSON.parse(response);

      if (data && data.status) {
        apiKeys.remove(id);
      }
    });
  };

  apiKeys.attachEvent('onAfterDelete', id => {
    app.trigger('apiKeys:updated');
  });

  apiKeys.attachEvent('onAfterAdd', id => {
    app.trigger('apiKeys:updated');
  });

  app.on('app:start', () => {
    // if (!rights.account.hasRight('api_settings')) {
    //   app.checkInit('apiKeys');
    //
    //   return false;
    // }

    api.get(`/team/apiKeys?${new Date().getTime()}`).then(response => {
      app.checkInit('apiKeys');
      apiKeys.parse(response.data);
    }).catch(() => {
      app.checkInit('apiKeys');
    });
  });
} else {
  app.checkInit('apiKeys');
}

export default apiKeys;
